export enum StatusIntegrationCompanyEnum {
  Active = 1,
  Suspended = 2
}